import React from 'react';
import { AuthLayout } from '../auth-layout.component';
import { CreateAccount } from './create-account.component';

export const RegisterScreen = (): React.ReactElement => {
    return <AuthLayout component={<CreateAccount />} />;
};
